import { IncidentModel } from './incident.model';

export class IncidentAbandonedVehicle extends IncidentModel {
    public landCategoryTypeId: number;
    public landCategoryTypeDisplayValue: string;
    public vin: string;
}
